import { render, staticRenderFns } from "./OMultiCheckbox.vue?vue&type=template&id=327874ce&scoped=true&"
import script from "./OMultiCheckbox.vue?vue&type=script&lang=js&"
export * from "./OMultiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./OMultiCheckbox.vue?vue&type=style&index=0&id=327874ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327874ce",
  null
  
)

export default component.exports